import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Avatar from 'common/components/user/Avatar';
import { path } from 'common/tools/network/routing';

import onlyIfHasSocial from 'website/components/HoC/onlyIfHasSocial';

import styles from './styles.module.scss';

const FolloweeWantToSeeDetail = props => {
  const {
    user: { mainAvatar, legacyId, nickname }
  } = props;

  const profileUrl = path('userprofile_index', {
    user: legacyId.toLowerCase()
  });

  return (
    <figure className={classNames(styles.followeeDetails, 'cf', 'hred')}>
      <a className={styles.followeeDetailsThumb} href={profileUrl}>
        <Avatar
          alt={nickname}
          className={styles.followeeAvatar}
          src={mainAvatar}
        />
      </a>
      <figcaption className={styles.followeeName}>{nickname}</figcaption>
    </figure>
  );
};

FolloweeWantToSeeDetail.propTypes = {
  user: PropTypes.shape({
    legacyId: PropTypes.string.isRequired,
    mainAvatar: PropTypes.string,
    nickname: PropTypes.string
  }).isRequired
};

export default onlyIfHasSocial(FolloweeWantToSeeDetail);
